/* 予約注文ポップアップ(商品詳細ページ設計 §3)
   Dawn既存の modal-dialog(global.js)の開閉・フォーカス管理を流用する。
   - 初回自動表示は主要要素の描画後、同一商品・同一発送文言でセッション中1回まで
   - テーマエディタ内では自動表示しない
   - sessionStorageが使えない環境でも購入操作を妨げない */

if (!customElements.get('ny-soda-preorder-notice')) {
  class NySodaPreorderNotice extends HTMLElement {
    connectedCallback() {
      // Dawnのproduct-infoがmodal-dialogをbody直下へ移動する場合があるためIDでも探す
      this.modal =
        this.querySelector('modal-dialog') ||
        (this.dataset.modalId ? document.getElementById(this.dataset.modalId) : null);
      this.reopenButton = this.querySelector('.ny-soda-preorder__reopen');
      this.confirmButton = this.modal
        ? this.modal.querySelector('.ny-soda-preorder__confirm')
        : null;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      if (this.reopenButton && this.modal) {
        this.reopenButton.addEventListener('click', () => this.modal.show(this.reopenButton), {
          signal,
        });
      }

      if (this.confirmButton && this.modal) {
        this.confirmButton.addEventListener('click', () => this.modal.hide(), { signal });
      }

      if (
        this.modal &&
        this.dataset.autoOpen === 'true' &&
        !(window.Shopify && window.Shopify.designMode)
      ) {
        // 主要要素の描画後に表示する(非表示タブでも発火するようsetTimeoutを使う)
        window.setTimeout(() => this.maybeAutoOpen(), 0);
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    storageKey() {
      // 商品IDと発送文言をキーに含め、発送条件の更新後は再表示されるようにする
      return `ny-soda-preorder-${this.dataset.productId}-${this.dataset.notice || ''}`;
    }

    maybeAutoOpen() {
      if (this.dataset.frequency === 'once_per_session') {
        let seen = false;
        try {
          seen = window.sessionStorage.getItem(this.storageKey()) === '1';
        } catch (error) {
          // ブラウザ保存が使えない場合は自動表示を控え、常設表示に任せる
          return;
        }
        if (seen) return;
        try {
          window.sessionStorage.setItem(this.storageKey(), '1');
        } catch (error) {
          return;
        }
      }
      // 自動表示はユーザー操作起点ではないので、開き元(opener)を渡さない。
    // 渡すと閉じたときにDawnがそのボタンへフォーカスを戻し、
    // ページが購入ボタン付近まで飛んでしまう(2026-08-19ユーザー報告)。
    // ユーザーが「発送について」を押して開いた場合は従来どおりそこへ戻る。
    this.modal.show();
    }
  }

  customElements.define('ny-soda-preorder-notice', NySodaPreorderNotice);
}
